import { ChangeDetectorRef, Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IBallotCommitteeMemberDto } from '../../../shared/models/ballot-base/ballot-committee-member-dto';
import { CiVoteId, ciVoteOption } from '../../../shared/models/ci/ci-vote';
import { ICommitteeInternalBallotDto } from '../../../shared/models/ci/committee-internal-ballot-dto';
import { IDonutChartItem } from '../../../../controls/donut-chart/donut-chart.component';
import { Country } from '../../../../../shared/constants/srs-ballot.constants';
import { UnifiedBallotStatus } from '../../../../../shared/enums/unified-ballot-status-enum';
import { AuthService } from '../../../../../shared/services/auth.service';
import { CibFinaliseBallotModalComponent } from '../cib-finalise-ballot-modal/cib-finalise-ballot-modal.component';

@Component({
    selector: 'app-ci-eligible-voters',
    templateUrl: './ci-eligible-voters.component.html',
    styleUrl: './ci-eligible-voters.component.scss',
    standalone: false
})
export class CiEligibleVotersComponent implements OnInit {

  @Input() ballotVotes: IBallotCommitteeMemberDto[] = [];
  @Input() isJoint: boolean = false;
  @Input() BallotStatus!: UnifiedBallotStatus | undefined;
  @Input() ciBallotDetailDto: ICommitteeInternalBallotDto | null = null;

  isShowingLocations: boolean = false;
  data: IDonutChartItem[] = [];
  eligibleVotes: IBallotCommitteeMemberDto[] = [];

  agreeCount: number = 0;
  disagreeCount: number = 0;
  noneCount: number = 0;

  selectedLocation: string = 'aus-nz';
  ballotType ='cibBallot';
  isConsensusVisible: boolean = false;
  isRefresh: boolean = true;
  isUserPmOrAboveOrHoSD: boolean = false;
  isValidStatusGenerateReport: boolean = false;
  canFinaliseBallot: boolean = false;

  constructor(private cdr: ChangeDetectorRef, public authService: AuthService, private _modalService: NgbModal) {}

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(this.ballotVotes && this.ballotVotes.length > 0) {
      this.checkConsensusVisible();
      this.filterEligibleVotes();
      this.getVoteDetails();
      this.checkNZCommittee();
      this.checkUserPermission();
      this.checkCIBallotStatus();
    }
  }

  checkUserPermission() {
    this.authService.isUserPmOrAboveOrHoSD().subscribe({
      next: (isAuthorized) => {
        this.isUserPmOrAboveOrHoSD = isAuthorized;
        this.canFinaliseBallot = isAuthorized && this.BallotStatus === UnifiedBallotStatus.closedForVoting;
      },
      error: (err) => {
        this.isUserPmOrAboveOrHoSD = false;
        console.error('Error checking authorisation:', err);
      }
    });
  }

  checkCIBallotStatus(){
    this.isValidStatusGenerateReport = this.BallotStatus === UnifiedBallotStatus.openForVoting || this.BallotStatus === UnifiedBallotStatus.closedForVoting || this.BallotStatus === UnifiedBallotStatus.finalised;
  }

  getVoteDetails(){
    const voteCounts = this.eligibleVotes.reduce((counts: {[key: string]: number}, vote) => {
      const type = vote.votes?.length > 0 ? vote.votes[0]?.voteOptionType : CiVoteId.NO_RESPONSE;
      if (type) {
        counts[type] = (counts[type] || 0) + 1;
      }
      return counts;
    }, {});

    // Assign counts to your specific variables
    this.agreeCount = voteCounts[CiVoteId.AGREE] || 0;
    this.disagreeCount = voteCounts[CiVoteId.DISAGREE] || 0;
    this.noneCount = voteCounts[CiVoteId.NO_RESPONSE] || 0;

    if(voteCounts) {
      this.generateDonutChart(voteCounts);
    }
  }

  filterByLocation(): void {
    const filteredVotes = this.eligibleVotes.filter((vote) => {
      const voteCountry = vote.country.toLowerCase();
      if (this.selectedLocation === 'aus-nz') {
        this.isRefresh = true;
        return (
          Country.Australia.includes(voteCountry) ||
          Country.NewZealand.includes(voteCountry)
        );
      } else if (this.selectedLocation === 'aus') {
        this.isRefresh = true;
        return Country.Australia.includes(voteCountry);
      } else if (this.selectedLocation === 'nz') {
        this.isRefresh = false;
        return Country.NewZealand.includes(voteCountry);
      }

      return false;
    });



    const voteCounts = filteredVotes.reduce(
      (counts: { [key: string]: number }, vote) => {
        const type = vote.votes?.length > 0 ? vote.votes[0]?.voteOptionType : CiVoteId.NO_RESPONSE;
        if (type) {
          counts[type] = (counts[type] || 0) + 1;
        }
        return counts;
      },
      {}
    );

    this.generateDonutChart(voteCounts);
    this.cdr.detectChanges();
  }



  generateDonutChart(voteCounts: any): void {
    const voteTypes = [
      CiVoteId.AGREE,
      CiVoteId.DISAGREE,
      CiVoteId.NO_RESPONSE,
    ];

    this.data = voteTypes.map((voteType) => ({
      label: ciVoteOption[voteType].text,
      value: voteCounts[voteType] || 0,
      color: ciVoteOption[voteType].color,
      icon: ciVoteOption[voteType].icon,
    }));
  }


  filterEligibleVotes() {
    // Filter votes based on eligibility
    this.eligibleVotes = this.ballotVotes.filter((vote) =>
      vote.isEligible
    );
  }

  checkNZCommittee(){
    const hasNZCommitteeVotes = this.ballotVotes.find(vote => vote.country && (Country.NewZealand.includes(vote.country.toLowerCase())));
    this.isShowingLocations = hasNZCommitteeVotes != null && this.isJoint;
  }

  checkConsensusVisible(){
    this.isConsensusVisible = (this.BallotStatus === UnifiedBallotStatus.openForVoting || this.BallotStatus === UnifiedBallotStatus.closedForVoting);
  }

  openFinaliseBallotModal() {
    const modalRef = this._modalService.open(CibFinaliseBallotModalComponent);
    modalRef.componentInstance.data = this.data;
    modalRef.componentInstance.ballotId = this.ciBallotDetailDto?.id || '';
  }

}

